<template>


    <div>

        <v-card-text>
         No news
        </v-card-text>

    </div>



</template>


<script>



    export default {


        name: 'newsWidget.vue',
        wconf: {

            title: 'dashboard.widget.title.news',
            location: 'secondary',
            position: 100,
            active: true

        },

        methods: {


            getTitle(){

                return this.$t('dashboard.widget.title.news')

            }

        },

        computed: {},
        mounted() {},
        created(){}



    }



</script>